'use client';

import toast from '@shared/utils/helpers/toast';
import { useEffect } from 'react';

// Handle this provider's OAuth redirect on mount; strip params so it runs once.
export function useOAuthReturn(
  provider: string,
  label: string,
  onCode: (code: string, state: string) => Promise<void>
) {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get('code');
    const oauthError = params.get('error');
    const errorDescription = params.get('error_description');
    const state = params.get('state');
    if (!code && !oauthError) return;
    if ((params.get('provider') ?? 'tiktok') !== provider) return;

    window.history.replaceState({}, '', window.location.pathname);
    if (oauthError) {
      // access_denied = the user hit Cancel. Anything else is a real provider
      // error (e.g. sandbox app: account not a Target User, scope not approved) —
      // surface the description so it's diagnosable instead of a generic "cancelled".
      // Use warn, not error: Next.js dev turns console.error into a blocking overlay.
      console.warn(`${label} OAuth error:`, oauthError, errorDescription);
      toast(
        oauthError === 'access_denied'
          ? `${label} connection was cancelled`
          : `${label} connection failed: ${errorDescription || oauthError}`
      );
      return;
    }
    if (code && state) void onCode(code, state);
  }, []);
}
